import { useSelector } from 'react-redux';
import { getSelectCategory } from '../selectors/categories';
import { getSelectProfile } from '../selectors/profiles';

export default function useRouteGuideItem(guideId) {
  const categoryGuideItem = useSelector(getSelectCategory(guideId));
  const profileGuideItem = useSelector(getSelectProfile(guideId));
  return categoryGuideItem || profileGuideItem;
}
